import {
  startCase, toLower, capitalize, upperFirst,
} from 'lodash';
import moment from 'moment';
import Cookies from 'js-cookie';
import routeConstants from './routeConstants';
import history from './history';
import client from '../client';
import { LOGOUT_USER } from '../graphql-client/mutations';
import {
  dateFormats, TIME_IN_NUMBER, NUMERIC_VALUE, MIME_TYPES, OFFER_STATUS, RECENT_ACTIVITIES_MESSAGES, RECENT_ACTIVITIES, regexPattern,
} from './constants';
import {
  MEDIA_ICON, DOC_ICON, PDF_ICON, XLS_ICON, FILE_ICON,
} from './image';

export const getCookie = (key) => JSON.parse(Cookies.get(key));
export const setDataToLocalStorag = (userData, condiion) => {
  const { token } = userData;
  if (condiion) {
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', token);
  }
};

export const getLocalUserData = () => JSON.parse(localStorage.getItem('user'));

export const updateKeyLocalUser = (key, value) => {
  const user = JSON.parse(localStorage.getItem('user'));
  user[key] = value;
  localStorage.setItem('user', JSON.stringify(user));
};

export const logOut = async () => {
  await client.mutate({
    mutation: LOGOUT_USER,
    variables: {},
  });
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('appliedOfferFilter');
  client.clearStore().then(() => {
    client.resetStore();
    history.push(routeConstants.LOGIN);
  });
};

export const handleGraphqlError = (error) => {
  if (error && error.graphQLErrors && error.graphQLErrors[0]) {
    return error.graphQLErrors[0].message;
  }
  if (error && error.message) {
    return error.message;
  }
  return '';
};

// export const capitalizeEveryWord = (word) => startCase(toLower(word));
export const capitalizeEveryWord = (word) => word?.toLowerCase()
  .split(' ')
  .map((s) => s?.charAt(0)?.toUpperCase() + s?.substring(1))
  .join(' ');

export const mapTagstoAPIRequest = (tags) => {
  const newTags = [];
  tags.forEach((element) => {
    newTags.push({
      name: element.label,
      _id: element.value,
    });
  });

  return newTags;
};

export const mapTagsFromAPIRequest = (tags) => {
  const newTags = [];
  tags.forEach((element) => {
    newTags.push({
      label: element.name,
      value: element._id || element.id,
    });
  });

  return newTags;
};

export const isSameDay = (d1, d2) => {
  d1 = new Date(d1);
  d2 = new Date(d2);
  return d1.getFullYear() === d2.getFullYear()
    && d1.getMonth() === d2.getMonth()
    && d1.getDate() === d2.getDate();
};

export const getTimeAgoFormat = (date) => {
  let returnVal;
  const currentDate = new Date();
  const createdDate = new Date(date);
  const dateDiff = (currentDate - createdDate) / NUMERIC_VALUE.THOUSAND;

  if (dateDiff < TIME_IN_NUMBER.MINUTE_SECONDS * NUMERIC_VALUE.TWO) {
    returnVal = 'Just now';
  } else if (dateDiff < TIME_IN_NUMBER.HOUR_SECONDS) {
    const minutes = Math.floor(dateDiff / TIME_IN_NUMBER.MINUTE_SECONDS);
    returnVal = `${minutes}m ago`;
  } else if (dateDiff < TIME_IN_NUMBER.DAY_SECONDS) {
    const hours = Math.floor(dateDiff / TIME_IN_NUMBER.HOUR_SECONDS);
    returnVal = `${hours}h ago`;
  } else {
    const days = Math.floor(dateDiff / TIME_IN_NUMBER.DAY_SECONDS);
    const dataToshow = days < NUMERIC_VALUE.TEN ? `${days}d ago` : `on ${moment(date).format(dateFormats.DATE_WITH_YEAR)}`;
    returnVal = dataToshow;
  }
  return returnVal;
};

export const nFormatter = (num) => {
  if (num >= NUMERIC_VALUE.BILLION) {
    return `${(num / NUMERIC_VALUE.BILLION).toFixed(1).replace(/\.0$/, '')}G`;
  }
  if (num >= NUMERIC_VALUE.TEN_LAKH) {
    return `${(num / NUMERIC_VALUE.TEN_LAKH).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (num >= NUMERIC_VALUE.THOUSAND) {
    return `${(num / NUMERIC_VALUE.THOUSAND).toFixed(1).replace(/\.0$/, '')}K`;
  }
  return num;
};

export const getDaysDiff = (startDate, endDate) => {
  const timeDiff = new Date(endDate) - new Date(startDate);
  return Math.ceil(timeDiff / (NUMERIC_VALUE.THOUSAND * NUMERIC_VALUE.SIXTY * NUMERIC_VALUE.SIXTY * NUMERIC_VALUE.TWENTY_FOUR));
};

/* function to calculate the difference between the end date and start date */
export const calculateDateDiff = (startDate, endDate, status, postEndDate) => {
  const daysDiff = getDaysDiff(startDate, endDate);
  let data;
  if (status === OFFER_STATUS.PUBLISHED) {
    data = `Posted on ${moment(postEndDate).format(dateFormats.DATE_WITHOUT_YEAR)}`;
  } else if (Object.is(daysDiff, -0)) {
    data = 'Expired';
  } else if (daysDiff === 0) {
    data = 'Due today';
  } else if (daysDiff < 0) {
    data = 'Expired';
  } else if (daysDiff === 1) {
    data = `Deadline to complete and publish your posts is in ${daysDiff} day`;
  } else {
    data = `Deadline to complete and publish your posts is in ${daysDiff} days`;
  }
  return data;
};

export const hashString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash += (str.charCodeAt(i) * 31) ** (str.length - i);
    // eslint-disable-next-line no-bitwise
    hash &= hash; // Convert to 32bit integer
  }
  return hash;
};

export function generateRoomId(userId) {
  let roomId = '';
  if (hashString(getLocalUserData()._id) <= hashString(userId)) {
    roomId = `${getLocalUserData()._id}-${userId}`;
  } else {
    roomId = `${userId}-${getLocalUserData()._id}`;
  }
  return roomId;
}

export const getMediaRenderTag = (file) => {
  if (file.type.indexOf('image') >= 0) {
    return URL.createObjectURL(file);
  }
  if (MIME_TYPES.VIDEO.indexOf(file.type) >= 0) {
    return MEDIA_ICON;
  }
  if (MIME_TYPES.DOC.indexOf(file.type) >= 0) {
    return DOC_ICON;
  }
  if (MIME_TYPES.PDF.indexOf(file.type) >= 0) {
    return PDF_ICON;
  }
  if (MIME_TYPES.XLS.indexOf(file.type) >= 0) {
    return XLS_ICON;
  }
  return FILE_ICON;
};

export const activityDescription = (activityType, email, offerInfo) => {
  const title = (offerInfo && offerInfo.title) ? offerInfo.title : '';
  switch (activityType) {
    case RECENT_ACTIVITIES.NEW_OFFER:
      return `${RECENT_ACTIVITIES_MESSAGES.NEW_OFFER} ${title}.`;
    case RECENT_ACTIVITIES.ARTIST_APPLIED:
      return `${RECENT_ACTIVITIES_MESSAGES.ARTIST_APPLIED} ${title}.`;
    case RECENT_ACTIVITIES.OFFER_ACCEPTED:
      return `${RECENT_ACTIVITIES_MESSAGES.OFFER_ACCEPTED} ${title}.`;
    case RECENT_ACTIVITIES.REJECT_OFFER_REQUEST:
      return `${RECENT_ACTIVITIES_MESSAGES.REJECT_OFFER_REQUEST} ${title}.`;
    case RECENT_ACTIVITIES.ACCEPT_CONTRACT:
      return `${RECENT_ACTIVITIES_MESSAGES.ACCEPT_CONTRACT} ${title}.`;
    case RECENT_ACTIVITIES.ADMIN_ACCEPTED:
      return `${RECENT_ACTIVITIES_MESSAGES.ADMIN_ACCEPTED} ${title}.`;
    case RECENT_ACTIVITIES.ADMIN_REJECTED:
      return `${RECENT_ACTIVITIES_MESSAGES.ADMIN_REJECTED} ${title}.`;
    case RECENT_ACTIVITIES.BETA_POST_REQUEST_REQUEST:
      return `${RECENT_ACTIVITIES_MESSAGES.BETA_POST_REQUEST_REQUEST} ${title}.`;
    case RECENT_ACTIVITIES.BETA_POST_APPROVE:
      return `Beta post on ${title} has been approved by BYGmusic.`;
    case RECENT_ACTIVITIES.BETA_POST_REJECT:
      return `Beta post on ${title} has been rejected by BYGmusic.`;
    case RECENT_ACTIVITIES.INVITE_MANAGER:
      return `You have invited ${email} to BYGmsuic.`;
    case RECENT_ACTIVITIES.CONTRACT_PENDING:
      return `You have a contract pending on ${title}.`;
    case RECENT_ACTIVITIES.MISSED_DEADLINE_BETA_POST:
      return RECENT_ACTIVITIES_MESSAGES.MISSED_DEADLINE;
    case RECENT_ACTIVITIES.PENDING_BETA_POST:
      return `You have a pending beta post on ${title}.`;
    default:
      break;
  }
  return null;
};

export const addHttpInUrl = (url) => {
  if (!regexPattern.ADD_HTTP.test(url)) {
    url = `http://${url}`;
  }
  return url;
};

export const renderDateRange = (offerStartDate, offerEndDate) => {
  let dateValue = '';
  if (isSameDay(offerStartDate, offerEndDate)) {
    dateValue = moment(offerStartDate).format(dateFormats.DATE_WITH_YEAR);
  } else {
    dateValue = `${moment(offerStartDate).format(dateFormats.DATE_WITHOUT_YEAR)} - ${moment(offerEndDate).format(dateFormats.DATE_WITH_YEAR)}`;
  }
  return dateValue;
};

export const formatedCurrency = (curValue = 0) => new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(curValue);

export const truncateLongString = (str, maxChars, useWordBoundary) => {
  if (str?.length <= maxChars) return str;
  const modifiedString = str.substr(0, maxChars - 1);
  const lastSpaceCharPosition = modifiedString.lastIndexOf(' ');
  const lastIndex = lastSpaceCharPosition !== -1 ? lastSpaceCharPosition : modifiedString.length;
  return `${useWordBoundary ? modifiedString.substr(0, lastIndex) : modifiedString}...`;
};
